<template>
  <div class="phone-index personal">
    <div class="title-box">
      <span class="text1">{{organizationName}}</span>
      <div class="right-btn">
        <i class="iconfont iconkefu"></i>
        <i class="iconfont iconshezhi"></i>
      </div>
    </div>
    <div class="user-box">
      <img src="@static/images/appConfig/userIcon.png" alt="">
      <div class="name-box">
        <span class="text1">蜡小烛</span>
        <span class="text2">高级营销总监</span>
      </div>
      <i class="iconfont iconchakangengduojiantou"></i>
    </div>
    <div class="empty-box" style="height:60px">我的财富</div>
    <div class="empty-box" style="height:60px">业绩</div>
    <div class="empty-box" v-if="!($units.isOkBao() || $units.isOkTX())" style="height:60px;width:167px;">我的客户</div>
    <div class="empty-box" v-if="!($units.isOkBao() || $units.isOkTX())" style="height:60px;width:167px;margin-left:10px;">我的访客</div>
    <div class="empty-box" v-if="$units.isOkBao() || $units.isOkTX()" style="height:60px">客户保单</div>
    <div  class="tools-list2" v-if="list1.length">
      <div class="tools-title">展业工具</div>
      <draggable class="list" v-model="list1" @update="sortEvent(list1)" @drop.native.stop>
        <div class="tools-item" v-for="(bean,i) in list1" :key="i">
          <img :src="bean.img" alt="">
          <span class="text">{{bean.name}}</span>
        </div>
      </draggable>
    </div>
    <div class="tools-list2" v-if="list2.length">
      <div class="tools-title">管理工具</div>
      <draggable class="list" v-model="list2" @update="sortEvent(list2)" @drop.native.stop>
        <div class="tools-item" v-for="(bean,i) in list2" :key="i">
          <img :src="bean.img" alt="">
          <span class="text">{{bean.name}}</span>
        </div>
      </draggable>
    </div>
    <div class="empty-box" v-if="$units.isOkBao() || $units.isOkTX()" style="height:60px;width:167px;">我的客户</div>
    <div class="empty-box" v-if="$units.isOkBao() || $units.isOkTX()" style="height:60px;width:167px;margin-left:10px;">我的访客</div>
    <phoneNav active="my"></phoneNav>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import phoneNav from "./phoneNav";
export default {
  components: {
    phoneNav,
    draggable,
  },
  mixins:[],
  props: ["organizationName"],
  data() {
    return {
      list:[],
      list1:[],
      list2:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    setData(list){
      this.list = list.filter(item=>{
        return item.enable==1
      });
      // 展业工具
      this.list1 = this.list.filter(item=>{
        return item.toolType==1
      });
      // 管理工具
      this.list2 = this.list.filter(item=>{
        return item.toolType==2
      });
    },
    sortEvent(list){
      const ids = list.filter(item=>{
        return item
      }).map(item=>{
        return item.id;
      })
      this.$http({
        url: "/buz/mcmMerchantModule/updateRank",
        type: "POST",
        data: {
          ids:ids.join(',')
        }
      }).then((res)=>{
        this.$emit("sort", list);
      })
    },
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneIndex.scss";
</style>
